<template>
  <b-list-group flush class="text-light text-left">
    <b-list-group-item
      v-for="satData in sortedSats"
      :key="satData.sat.id"
      :active="selectedSat && satData.sat.id == selectedSat.sat.id"
      @click="selectSat(satData)"
      class="d-flex justify-content-between align-items-center pointer"
    >
      {{satData.sat.name}}
      <b-badge variant="primary" v-b-tooltip.hover
                  v-bind:title="strings['Magnitude']"
            pill>{{formatMag(satData.mag)}}</b-badge>
    </b-list-group-item>
  </b-list-group>
</template>
<script>
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import numeral from "numeral";
import { mapState } from "vuex";
//import * as HA from "@h-a/astrolib";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  name: "VisibleSatelliteList",
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState([
      "utc",
      "culture",
      "strings",
      "currentlyVisibleSatellites",
      "selectedSat",
      "settings"
    ])
  },
  watch: {
    currentlyVisibleSatellites: function() {
      this.sortedSats = this.currentlyVisibleSatellites.slice();
      this.sortedSats.sort(this.settings.satSort == 'E' ? this.sortByElev : this.sortByMag);
    },
  }, 
  methods: {
    selectSat: function(satData) {
      this.$store.commit("setSelectedSat", satData);
    },
    formatMag: function(mag) {
      return numeral(mag).format("0,0.0");
    },
    sortByMag: function(a, b) {
      return a.mag - b.mag;
    },
    sortByElev: function(a, b) {
      return b.topoPos.latitude - a.topoPos.latitude;
    }
  },
  data() {
    return {
      sortedSats: null,
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
